// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"172dae22","455":"e41614c3","744":"07962261","893":"e4224fc5","977":"47f8a146"}[chunkId] + ".chunk.js";
};